class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.predictiveSearchForm = this.querySelector('form');

    this.input.form.addEventListener('reset', this.onFormReset.bind(this));
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    
    this.toggleResetButton();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.setAttribute("loading", !0);

    this.getSearchResults(searchTerm);
  }
  
  onFormReset(event) {
    this.close();
    this.input.value = '';
    this.toggleResetButton();
  }

  getSearchResults(searchTerm) {
    var fetch_root = '/search',
      search_url = this.predictiveSearchForm.getAttribute('action'); /* to ensure language/location is in root url, e.g. /en-uk/search */
    if(search_url.includes('/search')) {
      fetch_root = search_url.replace('/search/', '/search'); /* just in case */
    }
    fetch(`${fetch_root}/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        this.removeAttribute("loading");
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute("open", !0);
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.removeAttribute("open");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
